import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, LineChart, Line, Legend } from "recharts";
import { SALES_BY_CATEGORY, REVENUE_14D } from "../../data/adminData";
import { fmt } from "../../data/store";
import { PageTitle, Card } from "./ui";

const COLORS = ["#D0121A", "#111111", "#6B6B6B", "#E5A000", "#1E9E45", "#8A8A8A", "#C4C4C4"];

export default function Reports() {
  const total = SALES_BY_CATEGORY.reduce((s, c) => s + c.value, 0);
  return (
    <div data-testid="admin-reports">
      <PageTitle>Atskaites</PageTitle>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        {[
          ["Apgrozījums (30 d.)", fmt(total)],
          ["Konversijas līmenis", "2,8%"],
          ["Atkārtoto pirkumu daļa", "38%"],
          ["Vid. pasūtījuma vērtība", "57,03 €"],
        ].map(([l, v]) => (
          <Card key={l} className="p-5">
            <div className="text-xs uppercase tracking-widest text-[#6B6B6B] font-bold">{l}</div>
            <div className="text-2xl font-extrabold mt-2">{v}</div>
          </Card>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card className="p-5">
          <h2 className="text-sm font-bold uppercase tracking-widest mb-4">Pārdošana pa kategorijām</h2>
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie data={SALES_BY_CATEGORY} dataKey="value" nameKey="name" innerRadius={60} outerRadius={100}>
                {SALES_BY_CATEGORY.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip formatter={(v) => `${v} €`} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
            </PieChart>
          </ResponsiveContainer>
        </Card>
        <Card className="p-5">
          <h2 className="text-sm font-bold uppercase tracking-widest mb-4">Pasūtījumi pa dienām</h2>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={REVENUE_14D}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E2E2" />
              <XAxis dataKey="date" tick={{ fontSize: 10 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
              <Bar dataKey="orders" name="Pasūtījumi" fill="#111111" />
            </BarChart>
          </ResponsiveContainer>
        </Card>
        <Card className="p-5 lg:col-span-2">
          <h2 className="text-sm font-bold uppercase tracking-widest mb-4">Ieņēmumi un tendence (14 dienas)</h2>
          <ResponsiveContainer width="100%" height={240}>
            <LineChart data={REVENUE_14D}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E2E2" />
              <XAxis dataKey="date" tick={{ fontSize: 10 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip formatter={(v) => [`${v} €`, "Ieņēmumi"]} />
              <Line type="monotone" dataKey="revenue" stroke="#D0121A" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </Card>
      </div>
    </div>
  );
}
